import { injectable } from 'tsyringe';
import { authenticatedFetch } from '@/shared/auth/AuthenticatedFetch';
import type { ClassificationAssistPlan, ClassificationAssistRequest } from '@/shared/assist/ClassificationAssistContract';
import type { IClassificationAssistEngine } from './ClassificationAssistEngine';

const CLASSIFICATION_ASSIST_ROUTE = '/_assist/classifications';

/** Calls the BFF classification assist route over the authenticated fetch (CSRF header + session cookie). */
@injectable()
export class BffClassificationAssistEngine implements IClassificationAssistEngine {
    async suggest(request: ClassificationAssistRequest): Promise<ClassificationAssistPlan> {
        const response = await authenticatedFetch(CLASSIFICATION_ASSIST_ROUTE, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(request),
        });
        if (!response.ok) {
            throw new Error(await readError(response));
        }
        return (await response.json()) as ClassificationAssistPlan;
    }
}

async function readError(response: Response): Promise<string> {
    const body = await response
        .clone()
        .json()
        .then((value) => value as { error?: string })
        .catch(() => null);
    if (body !== null && typeof body.error === 'string' && body.error.length > 0) {
        return body.error;
    }
    return `Classification assist request failed (${response.status})`;
}
